export default __webpack_public_path__ + "static/media/cityportal.f3aaf848.svg";